import {registerPlugin} from "surveylabJsAssets/chart/charts";
import AbstractChart from "surveylabJsAssets/chart/plugin/abstract-chart";
import {Options} from "highcharts";

export class Distribution extends AbstractChart {
    protected allChartOptions(): Options {
        const options: Options = {
            chart: {
                type: 'column',
                height: 350,
                plotBackgroundColor: {
                    linearGradient: {x1: 0, y1: 0, x2: 1, y2: 0},
                    stops: [
                        [0, 'oklch(88.5% 0.062 18.334 / 0.85)'],
                        [1, 'oklch(93.8% 0.127 124.321 / 0.85)'],
                    ],
                },
            },
            yAxis: {
                gridLineWidth: 0,
                title: {
                    text: null,
                },
                labels: {
                    enabled: false,
                },
            },
            plotOptions: {
                column: {
                    borderColor: 'oklch(21% 0.034 264.665 / 0.5)',
                    dataLabels: {
                        enabled: true,
                        inside: true,
                        format: '{y}%',
                    }
                }
            },
            colors: ['oklch(21% 0.034 264.665 / 0.3)'],
        }

        return super.mergeOptions(super.allChartOptions(), options);
    }
}

// noinspection JSUnusedGlobalSymbols
export default function () {
    registerPlugin(Distribution)
}